import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './answerKeys.scss';
import sectionAnswerKeysSelector from '../../selectors/answerKeys/SectionAnswerKeysSelector';
import QuestionAnswerKeys from './QuestionAnswerKeys';
import marketplacePropertiesService from '../../services/MarketplacePropertiesService';

const SectionAnswerKeysPure = (props) => {
    const {
        sectionAnswerKeys,
        sectionTitle,
    } = props;
    // using a ref to store immutable value that doesn't get affected by re-renders
    const multiInteractionItemIndexFactor = useRef(0);
    const getScorableItemTitleRow = (itemAnswerKeys) => {
        const isGapMatchQuestionWithMultipleInteractions = itemAnswerKeys?.isMultipleInteractionGapMatchQuestion;
        const isEnableTwoInlineGapMatchAreas = marketplacePropertiesService.isEnableTwoInlineGapMatchAreas();

        const childKey = `${itemAnswerKeys.contentRevisionId}-${itemAnswerKeys.orderNumber}`;
        let itemIndexString = typeof itemAnswerKeys.itemIndex === 'number' ?
            itemAnswerKeys.itemIndex.toString() :
            itemAnswerKeys.itemIndex;
        if (isGapMatchQuestionWithMultipleInteractions) {
            if (typeof itemAnswerKeys.itemIndex === 'number' && itemAnswerKeys?.keys?.length &&
                itemAnswerKeys.itemIndex >= itemAnswerKeys.keys.length) {
                itemIndexString = multiInteractionItemIndexFactor.current;
                multiInteractionItemIndexFactor.current++;
            } else {
                multiInteractionItemIndexFactor.current = 0;
            }
        }

        return (<tr key={childKey}>
            <td className={styles.questionNumber}>
                {itemAnswerKeys.orderNumber}
            </td>

            <td className={isEnableTwoInlineGapMatchAreas && styles.questionAnswerKeys}>
                <QuestionAnswerKeys
                    isMatchingQuestion={itemAnswerKeys.isMatchingQuestion}
                    itemIndex={itemIndexString}
                    answerKeys={itemAnswerKeys.keys}
                />
            </td>
        </tr>);
    };

    return (<React.Fragment>
        <tr className={styles.sectionRow}>
            <td colSpan={2}>
                { sectionTitle }
            </td>
        </tr>

        { sectionAnswerKeys.map(getScorableItemTitleRow) }

    </React.Fragment>);
};

SectionAnswerKeysPure.propTypes = {
    sectionAnswerKeys: PropTypes.array.isRequired,
    sectionTitle: PropTypes.string.isRequired,
};

const SectionAnswerKeys = props => (
    <SectionAnswerKeysPure {...props} {...sectionAnswerKeysSelector.selectProps(props)} />
);

export default SectionAnswerKeys;

